<app-common-page-breadcrumbs [navigationData]="navigationData" [pageTitle]="title"></app-common-page-breadcrumbs>
<div class="h-10 visible-xs">
</div>
<div class="mobile-header hidden-xs ml-4 pt-1 pb-1">
  <span class="mobile-header">{{'heading.myAddressBook' | cxTranslate}}</span>
</div>

<div *ngIf="enableLoader" id="loader"></div>
<div *ngIf="noData && !enableLoader" class="text-center strong  text-primary mb-5">{{'home.contracts.Noresults' | cxTranslate }}</div>

<div *ngIf="!noData && !enableLoader"  class="container d-flex flex-column  justify-content-center  mt-n5">
  <table class="add-margin-mobile mb-5 mb-down" >
    <thead role="rowgroup" *ngIf="!noData">
      <tr role="row" class="bg-table-header border-bottom" *ngIf="!noData">
        <th class=' p-7'>{{'home.addressBooks.company' | cxTranslate }}</th>
        <th class=' p-7'>{{'home.addressBooks.billingAddress' | cxTranslate }}</th>
        <th class=' p-7'>{{'home.addressBooks.shippingAddress' | cxTranslate }}</th>
      </tr>
    </thead>
    <tbody role="rowgroup">
      <tr role="row" class="bg-white border-bottom" >
        <td  class=' p-7' [attr.data-label]="'home.addressBooks.company' | cxTranslate" role="cell">{{addressBookDetails.name | titlecase}}</td>
        <td  class=' p-7' [attr.data-label]="'home.addressBooks.billingAddress' | cxTranslate " role="cell">{{ addressBookDetails.billingAddress.formattedAddress !== null ? addressBookDetails.billingAddress.formattedAddress : 'home.quote.NA'| cxTranslate}}</td>
        <td  class=' p-7' [attr.data-label]="'home.addressBooks.shippingAddress' | cxTranslate " role="cell">{{ addressBookDetails.shippingAddress.formattedAddress !== null ? addressBookDetails.shippingAddress.formattedAddress : 'home.quote.NA'| cxTranslate}}</td>
      </tr>
    </tbody>
  </table>
</div>
